import React, { useState, useEffect } from "react";
import "./apiProductsList.css";
import FaSpinner from "../faSpinner/faSpinner";
import _ from "lodash";
import ProductPreview from "../productPreview/productPreview";
import useToken from "../../customHooks/useToken";
import useUserId from "../../customHooks/useUserId";
import APIProductService from "../../services/APIProductService";

const ApiProductsList = (props) => {
  const { category } = props;
  const csrfToken = useToken();
  // The backend filters the catalogue by the caller's roles/organizations. Sending the
  // anonymous id here (as before) showed logged-in users the anonymous catalogue: products
  // they could not open, and none of the ones granted only to their role.
  const userId = useUserId();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load the catalogue for the current user; reload if the user id changes (login/logout)
  useEffect(() => {
    let cancelled = false;
    const loadProducts = async () => {
      setLoading(true);
      setError(null);
      try {
        await APIProductService.getProductList(userId, csrfToken);
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    loadProducts();
    return () => {
      cancelled = true;
    };
  }, [userId]);

  // Get filtered products directly from service - no useMemo needed
  const parsedData = loading
    ? []
    : APIProductService.getProductsByCategory(category);

  // Check loading/error states
  if (loading) {
    return <FaSpinner loading />;
  }

  if (error) {
    return <div>Error loading products. Please try again.</div>;
  }

  return (
    <div className="choises">
      {_.sortBy(parsedData, ["weight", "title"]).map((product) => {
        const { uuid, description, disable_documentation } = product;
        return (
          <ProductPreview
            {...product}
            key={uuid}
            animated
            body={description}
            disable_documentation={disable_documentation}
          />
        );
      })}
      {/* visual spacer at end of list */}
      <div className="product-list-spacer" aria-hidden="true" />
    </div>
  );
};

export default ApiProductsList;
